import React from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import "./PublicLayout.css";
import PublicVerifiedTradeHeader from "../../pages/PublicVerifiedTrade/PublicVerifiedTradeHeader";
import { Container } from "react-bootstrap";
import PublicVerifiedFooter from "../../pages/PublicVerifiedTrade/PublicVerifiedFooter";

const PublicSearchLayout = () => {
  const location =useLocation();
  return (
    <div className="publicWebLayout">
      <Container fluid  className='p-0'>
        <PublicVerifiedTradeHeader />
        <div className="custom-container">
         <Outlet />
        </div>
        <ScrollRestoration />
        <PublicVerifiedFooter />
      </Container>
    </div>
  );
};

export default PublicSearchLayout;
